<script lang="ts">
	import { onMount } from 'svelte';
	import { onFirstInteraction } from '#lib/utils/onFirstInteraction/onFirstInteraction.js';
	import { HUBSPOT_PORTAL_ID } from '#lib/websites/news/constants/hubspot.js';
	import { whenPageIdle } from '$global/utils/whenPageIdle/whenPageIdle';

	// HubSpot's loader expects this id on its script tag.
	const HUBSPOT_SCRIPT_ID = 'hs-script-loader';

	// The HubSpot tracking code runs one 1.5–2.7 s main-thread task under
	// Lighthouse mobile throttling. Injected from <head>, that task landed during
	// hydration and held back the first render, so it is only added once the
	// page has loaded and gone idle — or earlier, on the visitor's first
	// interaction, so an engaged visitor who leaves quickly is still tracked.
	onMount(() => {
		const injectHubSpot = () => {
			cancelIdle();
			cancelInteraction();

			if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
				return;
			}

			const script = document.createElement('script');
			script.id = HUBSPOT_SCRIPT_ID;
			script.async = true;
			script.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
			document.head.appendChild(script);
		};

		const cancelIdle = whenPageIdle(injectHubSpot);
		const cancelInteraction = onFirstInteraction(injectHubSpot);

		return () => {
			cancelIdle();
			cancelInteraction();
		};
	});
</script>
